"use client";

import type React from "react";
import { useEffect, useState } from "react";
import { API_ORIGIN, categoryAPI, type Collection } from "../services/api";
import { VideoPlayer } from "../components/ui/VideoPlayer";
import { SeoHelmet } from "../components/SeoHelmet";
import LogoLoader from "../components/ui/LogoLoader";
import { DEFAULT_DESCRIPTION } from "../config/seo";
import { productThumbUrl } from "../utils/mediaUrls";
import "./CatalogPage.css";

const CatalogPage: React.FC = () => {
  const [categories, setCategories] = useState<Collection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await categoryAPI.getAll();
        setCategories(
          [...response.data].sort((a, b) =>
            a.name.localeCompare(b.name, "ru", { sensitivity: "base" }),
          ),
        );
        setLoading(false);
      } catch (err) {
        setError("Ошибка загрузки категорий");
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) {
    return (
      <>
        <SeoHelmet title="Каталог тканей" description={DEFAULT_DESCRIPTION} path="/catalog" />
        <div className="catalog-page">
          <div className="container">
            <LogoLoader />
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <SeoHelmet title="Каталог тканей" description={DEFAULT_DESCRIPTION} path="/catalog" />
        <div className="catalog-page">
          <div className="container">
            <div className="error-state">{error}</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div
      className="catalog-page"
    >
      <SeoHelmet
        title="Каталог тканей"
        description="Коллекции и категории тканей ТЕКС МОЛЛ. Выберите категорию и смотрите доступные материалы."
        path="/catalog"
      />
      {/* <div className="catalog-hero">
        <div className="container">
          <h1 className="catalog-title">Каталог тканей</h1>
          <p className="catalog-subtitle">Выберите категорию тканей для просмотра доступных вариантов</p>
        </div>
      </div> */}

      <section className="catalog-content">
        
          {categories.length === 0 ? (
            <div className="empty-state reveal">
              <h3>Каталог пуст</h3>
              <p>В данный момент категории тканей не добавлены</p>
            </div>
          ) : (
            <div className="catalog-grid reveal-stagger">
              {categories.map((category) => {
                const featured =
                  category.products.find(
                    (product) => product.id === category.featuredProductId,
                  ) ?? category.products[0];
                const rel = featured?.videos?.[0];
                const norm = rel != null && String(rel).trim() ? String(rel).trim().replace(/\\/g, "/") : "";
                const videoSrc = norm ? `${API_ORIGIN}${norm.startsWith("/") ? "" : "/"}${norm}` : null;
                const imageRel = featured?.images?.[0];
                const imageNorm = imageRel != null && String(imageRel).trim() ? String(imageRel).trim().replace(/\\/g, "/") : "";
                const imageSrc = imageNorm
                  ? productThumbUrl(`${API_ORIGIN}${imageNorm.startsWith("/") ? "" : "/"}${imageNorm}`)
                  : null;

                return (
                  <div key={category.id} className="category-card reveal-child">
                    <div className="category-overlayer">
                      {videoSrc ? (
                        <VideoPlayer className="category-video" src={videoSrc} />
                      ) : imageSrc ? (
                        <img className="category-video" src={imageSrc} alt={category.name} />
                      ) : null}
                      <div className="category-content">
                        <h3>{category.name}</h3>
                        <a
                          href={`/category/${category.id}`}
                          className="btn btn-outline"
                        >
                          Смотреть
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
      </section>
    </div>
  );
};

export default CatalogPage;
